import { NgModule, ApplicationRef, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { HttpModule, JsonpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import {MomentModule} from 'angular2-moment';
import 'hammerjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// Main
import { AppMainComponent } from './layout/main.component';
import { SlimScrollDirective } from './layout/slim-scroll.directive';
import { PreloaderDirective } from './layout/preloader.directive';
// Header
import { AppHeaderComponent } from './layout/header/header.component';
// Sidenav
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';

// Footer
import { AppFooterComponent } from './layout/footer/footer.component';


// Pages
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageLoginComponent } from './extra-pages/login/login.component';
import { PageDownloadSCAL360Component } from './extra-pages/DownloadSCAL360/DownloadSCAL360.component';
import {PageLayoutViewChangeLogComponent} from './extra-pages/changelog/changelog.component';

import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
// Sub modules
import { MainModule } from './layout/main.module';
import { SharedModule } from './shared/shared.module';

// hmr
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

// Code By Megha
import { AdalAccessGuard } from './shared/adal-access.guard';
import { AuthInterceptor, DEFAULT_TIMEOUT } from './shared/auth-interceptor';
import { AdalService } from './shared/adal.service';
import { AuthService } from './shared/auth.service';
import { AppLoaderService } from '../services/app-loader/app-loader.service';
import { AppLoaderComponent} from '../services/app-loader/app-loader.component';
import { NotificationService } from './services/NotificationService';
import { LicensePortalModule } from './license-portal/license-portal.module';
import { LicensePortalComponent } from './license-portal/license-portal.component';
import { LicenseSideNavComponent } from './layout/license-sidenav/license-sidenav.component';
import { LicenseService } from './services/LicenseService';
import { ExportToCSVService } from './services/ExportToCSVService';
import { HomePageComponent } from './extra-pages/HomePage/home-page.component';
import { PageLayoutUserComponent } from './user-management/user/user.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserManagementModule } from './user-management/user-management.module';
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { AdvertisementRoutingModule } from './advertisement/advertisement-routing.module';
import { AdvertisementModule } from './advertisement/advertisement.module';
import { AuthGuard } from './shared/auth-admin.guard';
import { AccessDeniedComponent } from './layout/access-denied/access-denied.component';
import { LicenseAuthGuard } from './shared/license-auth.guard';
import { OTAAuthGuard } from './shared/ota-auth.guard';


@NgModule({
    imports: [
        HttpClientModule,
        BrowserAnimationsModule,
        BrowserModule,
        HttpModule,
        JsonpModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MomentModule,
        AppRoutingModule,
        AdvertisementRoutingModule,
        // Sub modules
        MainModule,
        SharedModule,
        Ng2FilterPipeModule,

        //license
        LicensePortalModule,

        //user management
        UserManagementModule,

        //Advertisement
        AdvertisementModule
        
    ],
    declarations: [
        AppComponent,        

        // Main
        AppMainComponent,
        SlimScrollDirective,
        PreloaderDirective,

        // Header
        AppHeaderComponent,
        AppMainComponent,
        // Sidenav
        AppSidenavComponent,
        LicenseSideNavComponent,
        ToggleOffcanvasNavDirective,
        AutoCloseMobileNavDirective,
        AppSidenavMenuComponent,       
        // Footer
        AppFooterComponent,

       

        // Dashboards
        DashboardComponent,        
        
        // Pages
        PageDownloadSCAL360Component,
        PageLoginComponent,               
        PageLayoutViewChangeLogComponent,

        //license
        LicensePortalComponent,

        //UserManagement
        UserManagementComponent,

        //home-page
        HomePageComponent,
        //advertisement
        AdvertisementComponent,
        AccessDeniedComponent
        ],        
    bootstrap: [AppComponent],
    providers: [AdalService, AdalAccessGuard, AuthGuard,LicenseAuthGuard,OTAAuthGuard,{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },      
        { provide: DEFAULT_TIMEOUT, useValue: 300000 },AppLoaderService,AuthService,NotificationService,LicenseService,ExportToCSVService],  
    entryComponents: [AppLoaderComponent,PageLayoutViewChangeLogComponent]    
})
export class AppModule {
    constructor(public appRef: ApplicationRef) { }
    hmrOnInit(store) {
        console.log('HMR store', store);
    }
    hmrOnDestroy(store) {
        let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
        // recreate elements
        store.disposeOldHosts = createNewHosts(cmpLocation);
        // remove styles
        removeNgStyles();
    } 
    hmrAfterDestroy(store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    }    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts